module.exports = __webpack_public_path__ + "static/img/ke.dd8a91b8.svg";